import axios from 'axios';
import { API_BASE_URL } from './axiosConfig';
// 송장 대량 출력용 주문번호 저장
export const savePrintOrders = async (orderNumbers) => {
    try {
        console.log('송장 대량 출력용 주문번호 저장 요청:', orderNumbers);
        const response = await axios.post(`${API_BASE_URL}/api/print-orders/save`, {
            orderNumbers
        });
        console.log('송장 출력용 주문번호 저장 성공:', response.data);
        return response.data;
    }
    catch (error) {
        console.error('송장 출력용 주문번호 저장 실패:', error);
        throw error;
    }
};
// 송장 출력용 주문번호 조회
export const getPrintOrders = async () => {
    try {
        console.log('송장 출력용 주문번호 조회 요청');
        const response = await axios.get(`${API_BASE_URL}/api/print-orders`);
        console.log('송장 출력용 주문번호 조회 성공:', response.data);
        return response.data;
    }
    catch (error) {
        console.error('송장 출력용 주문번호 조회 실패:', error);
        throw error;
    }
};
export const preflightCheonilPrintOrders = async (orderNumbers) => {
    try {
        const normalizedOrderNumbers = (orderNumbers || [])
            .map((value) => String(value || '').trim())
            .filter(Boolean);
        console.log('천일 출력 사전 점검 요청:', normalizedOrderNumbers);
        const response = await axios.post(`${API_BASE_URL}/api/print-orders/cheonil-preflight`, {
            orderNumbers: normalizedOrderNumbers
        });
        console.log('천일 출력 사전 점검 응답:', response.data);
        return response.data;
    }
    catch (error) {
        console.error('천일 출력 사전 점검 오류:', error);
        throw error;
    }
};
